export const tooltipTitle = "Qu'est-ce que le prix barré ?";
export const tooltipText = "C'est le prix le plus bas que le vendeur a pratiqué au cours des 30 jours précédant l'application de la réduction de prix.";
export const tooltipLink = 'En savoir plus';
export const tooltipUrl = 'https://help.fr.shopping.rakuten.net/hc/fr/articles/8203205392530';
